import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import excerptHtml from "excerpt-html"
import MenuItems from "./menu/MenuItems"
import Typography from "@material-ui/core/Typography"

import Arrow from "../images/arrow_forward.svg"

import * as theme from "../theme"

const SideBar = () => {
  // wrap sidebar in a span for sticky fix in FF
  return (
    <span style={{ marginRight: "40px" }}>
      <Container>
        <ProductsLink to="/products">
          <Typography variant="h3" component="div" color="inherit" gutterBottom>
            Products
          </Typography>
        </ProductsLink>

        <List>
          <MenuItems slug="sidebar">
            {items => {
              return items.map((item, index) => (
                <Item
                  key={index}
                  to={item.pathname}
                  className="menu-item-link"
                  activeClassName="active-item"
                >
                  <ItemTitle
                    variant="caption"
                    color="inherit"
                    className="menu-item-title"
                  >
                    {excerptHtml(item.title, {
                      pruneLength: 30,
                      pruneString: "…"
                    })}
                  </ItemTitle>
                  <Arrow />
                </Item>
              ))
            }}
          </MenuItems>
        </List>
      </Container>
    </span>
  )
}

export default SideBar

const ProductsLink = styled(Link)`
  padding: 11px 20px 0;
  margin-bottom: 1px;
  display: flex;
  background: ${theme.color.green};
  color: white;
  text-decoration: none;
`
const ItemTitle = styled(Typography)`
  && {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.125;
    letter-spacing: 0.85px;
  }
`

const Container = styled.div`
  @media (max-width: 799px) {
    display: none;
  }
  position: sticky;
  top: 120px;
  flex-shrink: 0;
  margin-bottom: auto;
  /* margin-right: 40px; */
`
const List = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  .menu-item-link,
  menu-item-title,
  .active-item {
    transition: all 0.12s ease-in-out;
  }
  .menu-item-link:nth-child(even) {
    background: #ebebeb;
  }
  .menu-item-link:nth-child(odd) {
    background: #f6f6f6;
  }

  .menu-item-link:hover {
    background: #d6d6d6;
  }

  .active-item {
    .menu-item-title {
      font-weight: bold;
    }
    background: ${theme.color.lightGreen} !important;
    color: white;
    svg {
      fill: #187e3f;
    }
  }
`
const Item = styled(Link)`
  margin-bottom: 1px;
  padding: 11px 20px;
  text-decoration: none;
  color: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
  svg {
    flex-shrink: 0;
    transform: translateX(-3px);
    transition: all 100ms ease-in-out;
    fill: #bcbdbc;
    width: 17px;
    height: 16px;
    margin-left: 50px;
  }
  &:hover {
    svg {
      transform: translateX(0px);
    }
  }
`
